<script setup lang="ts">
    import BaseButton from '@/components/BaseButton.vue';
    import { computed } from 'vue';

    const model = defineModel<string>({ default: '#000000' });
    const colorStyle = computed(() => {
        return {
            backgroundColor: model.value,
        };
    });
</script>

<template>
    <BaseButton
        disable-hover
        variant="outlined"
        class="h-12 w-12"
    >
        <span class="sr-only"> {{ $t('color_picker') }} </span>
        <span
            class="h-7 w-7 rounded-full border border-border-primary"
            :style="colorStyle"
        ></span>
    </BaseButton>
</template>
